var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0eeea12d\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./graph-legend.vue")
}
var normalizeComponent = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"configFile\":\"/usr/build/babel.config.js\"}!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./graph-legend.vue"
import __vue_script__ from "!!babel-loader?{\"configFile\":\"/usr/build/babel.config.js\"}!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./graph-legend.vue"
/* template */
import __vue_template__ from "!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0eeea12d\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./graph-legend.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eeea12d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "client/containers/workflow-history/components/workflow-graph/components/graph-legend.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0eeea12d", Component.options)
  } else {
    hotAPI.reload("data-v-0eeea12d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/containers/workflow-history/components/workflow-graph/components/graph-legend.vue
// module id = 1657
// module chunks = 0